import React from 'react'
import PropTypes from 'prop-types'

import { getSVG } from './../../helpers/util'

import './Hero.scss'

const loginBg = getSVG('loginBg')

const Hero = ({ title, subTitle, className }) => {
  return (
    <div
      className={`HeroContainer__div ${className}`}
      style={{ backgroundImage: `url(${loginBg})`, backgroundSize: 'cover' }}
    >
      <section className="hero">
        <div className="hero-body">
          <div className="container">
            <h1 className="title">{title}</h1>
            <h2 className="subtitle">{subTitle}</h2>
          </div>
        </div>
      </section>
    </div>
  )
}

Hero.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  backgroundImage: PropTypes.string,
  className: PropTypes.string
}

Hero.defaultProps = {
  title: '',
  subTitle: '',
  backgroundImage: '',
  className: ''
}

export default Hero
